<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card>
      <b-row
        align-v="center"
        align-h="between"
      >
        <b-col cols="auto">
          {{ $t("new_Ticket_description") }}
        </b-col>
        <b-col
          cols="auto"
          class="mt-2 mt-md-0"
        >
          <b-button
            variant="primary"
            :to="{ name: 'tickets-create' }"
          >
            {{ $t("new_ticket") }}
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card v-if="unReadtickets.length !== 0">
      <b-row
        class="mt-2 font-weight-bold"
        align-h="between"
      >
        <b-col cols="auto">
          <h2>{{ $t("open_tickets") }}</h2>
        </b-col>
        <b-col cols="auto">
          <b-form-group
            label-for="search1"
            style="width:200px;"
          >
            <b-form-input
              id="search1"
              v-model="openTicketSearch"
              :placeholder="$t('search')"
              autocomplete="none"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        class="mt-1"
        align-h="center"
      >
        <b-table
          responsive
          striped
          hover
          sticky-header="1000px"
          no-border-collapse
          :current-page="currentUnreadPage"
          :per-page="per_page"
          :fields="openedfields"
          :items="searchedUnreadTicket"
          sort-by="TheColumnToSort"
          :sort-desc="true"
          :tbody-tr-class="rowClass"
          @row-clicked="onRowSelected"
        >
          <template #cell(status_value)="data">
            <div v-if="data.item.read_by === 'user'">
              <span>{{ $t('operator-response') }}</span>
            </div>
            <div v-if="data.item.read_by === 'operator'">
              <span>{{ $t('your-response') }}</span>
            </div>
          </template>
          <template #cell(created_at)="data">
            <span>{{ getFormattedDate(data.item["created_at"]) }}</span>
          </template>
          <template #cell(actions)="data">
            <b-button
              variant="primary"
              @click="() => onRowSelected(data.item)"
            >
              {{ $t('details') }}
            </b-button>
          </template>
          <template #cell(updated_at)="data">
            <span :dir=" $i18n.locale ==='fa' ? 'ltr' : ''">{{
              new Date(data.item["updated_at"]).toLocaleString($i18n.locale)
            }}</span>
          </template>
          <template #cell(title)="data">
            <span>{{
              data.item.title.length > 30
                ? data.item.title.substring(0, 30) + "..."
                : data.item.title
            }}</span>
          </template>
          <template #cell(context)="data">
            <span>{{
              data.item.context.length > 20
                ? data.item.context.substring(0, 20) + "..."
                : data.item.context
            }}</span>
          </template>
          <template #cell(details)="data">
            <b-button
              variant="outline-primary"
              @click="() => onRowSelected(data.item)"
            >{{ $t("more_details") }}</b-button>
          </template>
        </b-table>
        <div v-if="!searchedUnreadTicket.length">
          {{ $t('no_item_exsist') }}
        </div>
        <b-pagination
          v-if="searchedUnreadTicket.length > per_page"
          v-model="currentUnreadPage"
          :total-rows="searchedUnreadTicket.length"
          :per-page="per_page"
          align="fill"
          size="sm"
          class="mt-2 mb-1"
        />
      </b-row>
    </b-card>

    <b-overlay
      :show="readTicketShow"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card>
        <b-row
          class="mt-2 font-weight-bold"
          align-h="between"
        >
          <b-col cols="auto">
            <h2>{{ $t("closed_tickets") }}</h2>
          </b-col>
          <b-col cols="auto">
            <b-form-group
              label-for="search2"
              style="width:200px;"
            >
              <b-form-input
                id="search2"
                v-model="closedTicketSearch"
                type="text"
                :placeholder="$t('search')"
                @input="closedSearch"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          class="mt-1 readTicket"
          align-h="center"
        >
          <b-table
            responsive
            striped
            sticky-header="1000px"
            hover
            no-border-collapse
            :fields="closedfields"
            :items="readTickets"
            :tbody-tr-class="rowClass"
            :sort-compare="()=>false"
            @row-clicked="onRowSelected"
            @sort-changed="sortChanged"
          >
            <template #cell(status_value)="data">
              <span
                :class="data.item.status_id == 1 ? 'text-green' : 'text-red'"
              >{{ data.item["status_value"] }}
              </span>
            </template>
            <template #cell(updated_at)="data">
              <span>{{
                new Date(data.item["updated_at"]).toLocaleString($i18n.locale)
              }}
              </span>
            </template>
            <template #cell(title)="data">
              <span>{{
                data.item.title.length > 15
                  ? data.item.title.substring(0, 15) + "..."
                  : data.item.title
              }}</span>
            </template>
            <template #cell(context)="data">
              <span>{{
                data.item.context.length > 20
                  ? data.item.context.substring(0, 20) + "..."
                  : data.item.context
              }}</span>
            </template>
            <template #cell(created_at)="data">
              <span>{{ getFormattedDate(data.item["created_at"]) }}</span>
            </template>
            <template #cell(actions)="data">
              <b-button
                variant="primary"
                @click="() => onRowSelected(data.item)"
              >
                {{ $t('details') }}
              </b-button>
            </template>
            <template #cell(details)="data">
              <b-button
                variant="outline-primary"
                @click="() => onRowSelected(data.item)"
              >{{ $t("more_details") }}</b-button>
            </template>
          </b-table>
          <div v-if="!readTickets.length">
            {{ $t('no_item_exsist') }}
          </div>
          <b-pagination
            v-if="totalReadTickets > per_page"
            v-model="page"
            :total-rows="totalReadTickets"
            :per-page="per_page"
            align="fill"
            size="sm"
            class="mt-2 mb-1"
          />
        </b-row>
      </b-card>
    </b-overlay>
  </b-overlay>
</template>

<script>
import Tickets from '@/views/logics/tickets/Tickets'

export default {
  mixins: [Tickets],

}
</script>

<style>
.text-red {
  color: red;
  font-weight: bold;
}

.text-green {
  color: green;
  font-weight: bold;
}

.unread-background-color {
  background-color: #d0d2d6 !important;
}
</style>
